<template>
  <div>
    <modal-gestor :opened="modalNotificacoes && !pedidoPreviewId" no-pad="true" width="medium">
      <div class="modal-nov-body pt-3 px-3 bg-light">
        <modal-menu v-if="!load" :menus="menus" :selected="menu" @changeMenu="toggleMenu"/>
        <alertas v-show="menu === 1" ref="alertas" :aberto="!!modalNotificacoes && menu === 1" :alertas="alertas" :carregando="loadAlertas"
                 @ignorar="ignorarAlerta" @responder="confirmarResposta"
                 @ignorar-grupo="ignorarAlertas" @ver-pedido="abrirPedido"/>
        <ocorrencias v-show="menu === 2" :itens="ocorrencias" @limpar="clearOcorrencias"/>
        <loading v-if="load" v-show="menu === 3"/>
        <comunicados v-show="menu === 3 && !load" :aberto="!!modalNotificacoes && menu === 3" :informes="informes"/>
      </div>
      <div class="text-center py-3 border-top">
        <button class="btn btn-dark px-4 py-2" @click="fechar()">Fechar</button>
      </div>
    </modal-gestor>
    <modal-pedido-preview v-if="modalNotificacoes && pedidoPreviewId" :pedido-id="pedidoPreviewId"
                          @voltar="pedidoPreviewId = null"/>
  </div>
</template>

<script>
import ModalGestor from "@/components/gestor/ModalGestor";
import Loading from "@/components/commons/Loading";
import ModalMenu from "@/components/commons/ModalMenu";
import Ocorrencias from "./Ocorrencias";
import Comunicados from "./Comunicados";
import Alertas from "./Alertas";
import ModalPedidoPreview from "@/components/gestor/ModalPedidoPreview";

export default {
  name: "ModalNotificacoes",
  components: {ModalPedidoPreview, Comunicados, Alertas, Ocorrencias, ModalMenu, Loading, ModalGestor},
  data() {
    return {
      load: false,
      informeCallbacks: [],
      loadAlertas: false,
      alertaTimeout: null,
      alertaIntervalo: null,
      alertaSocketDesconectado: false,
      alertasCarregados: false,
      alertaBuscaPendente: false,
      alertaNotificarPendente: false,
      alertaTocarSomPendente: false,
      alertaTipoPendente: null,
      alertaCallbacks: [],
      alertasIgnorando: [],
      modalNotificacoes: false,
      pedidoPreviewId: null,
      avisosLidos: [],
      menu: 3,
      loaded: false,
      menus: [
        { nome: 'Alertas', active: true },
        { nome: 'Ocorrências', active: true },
        { nome: 'Comunicados', active: true }
      ]
    }
  },

  methods: {
    openModal(manual, menu, tipoAlerta) {
      this.menu = menu || 3;
      this.modalNotificacoes = true;
      this.$nextTick(() => {
        this.$refs.alertas.selecionarTipo(manual ? null : tipoAlerta);
      });

      const carregar = () => {
        this.selecionarMenuInicial();
        if (menu) {
          this.menu = menu;
        } else if (manual) {
          this.avisosLidos = this.informes.map(a => a.id_informe);
          localStorage.setItem('avisosLidos', JSON.stringify(this.avisosLidos));
          this.atualizarContador(true);
        }
      };

      if (menu) {
        carregar();
      } else if (!this.loaded) {
        this.getInformes(carregar);
      } else {
        carregar();
      }

    },

    fechar() {
      this.pedidoPreviewId = null;
      this.$store.state.modalOcorrencia = false;
      this.modalNotificacoes = false;
    },

    getInformes(callback) {
      if (callback) this.informeCallbacks.push(callback);
      if (this.load) return;

      this.avisosLidos = JSON.parse(localStorage.getItem('avisosLidos') || '[]');
      this.load = true;
      this.$http.get('informes?status=1').then(res => {
        this.load = false;
        this.$store.state.informes = res.data || [];
        this.$store.state.informesCarregados = true;
        this.loaded = true;
        this.informeCallbacks.splice(0).forEach(cb => cb());
      }, () => {
        this.load = false;
        this.informeCallbacks = [];
      });
    },

    normalizarAlerta(alerta) {
      return {
        id: alerta.id_alerta,
        pedidoId: alerta.id_pedido || null,
        tipo: Number(alerta.tipo_alerta),
        titulo: alerta.titulo || 'Alerta',
        mensagem: alerta.mensagem || '',
        expiraEm: alerta.expires_at ? this.$dayjs(alerta.expires_at).valueOf() : null,
        expirado: !!alerta.expirado,
        criadoEm: alerta.created_at ? this.$dayjs(alerta.created_at).valueOf() : null,
        acoes: (alerta.acoes || []).map(acao => ({
          resposta: Number(acao.resposta),
          nome: acao.nome,
          label: acao.label,
          exigeMotivo: !!acao.exige_motivo,
          motivos: (acao.motivos || []).map(motivo => ({ valor: motivo.valor, label: motivo.label })),
          metadata: acao.metadata || null
        })),
        processando: false,
        original: alerta
      };
    },

    getAlertas(callback, notificarNovos, tocarSom) {
      if (callback) {
        this.alertaCallbacks.push(callback);
      }

      if (this.loadAlertas) {
        this.alertaBuscaPendente = true;
        this.alertaNotificarPendente = this.alertaNotificarPendente || !!notificarNovos;
        this.alertaTocarSomPendente = this.alertaTocarSomPendente || !!tocarSom;
        return;
      }

      const idsAtuais = this.alertas.map(alerta => alerta.id);
      const compararNovos = this.alertasCarregados && !!notificarNovos;
      const tocarSomNovos = tocarSom === undefined ? !!notificarNovos : !!tocarSom;
      this.loadAlertas = true;
      this.$http.get('v2/alertas').then(res => {
        const alertas = (Array.isArray(res.data) ? res.data : [])
          .filter(alerta => !this.alertasIgnorando.includes(alerta.id_alerta));
        this.$store.commit('setAlertas', alertas.map(alerta => this.normalizarAlerta(alerta)));
        this.alertasCarregados = true;
        this.loadAlertas = false;
        this.atualizarContador();

        const possuiNovos = this.alertas.some(alerta => !idsAtuais.includes(alerta.id));
        if ((compararNovos || this.alertaNotificarPendente) && possuiNovos) {
          this.alertaNotificarPendente = false;
          if (tocarSomNovos || this.alertaTocarSomPendente) {
            this.playNotification(2);
          }
          this.alertaTocarSomPendente = false;
          const tipoAlerta = this.alertas.some(alerta => alerta.tipo === this.alertaTipoPendente && !idsAtuais.includes(alerta.id))
            ? this.alertaTipoPendente
            : null;
          this.openModal(false, 1, tipoAlerta);
        }

        this.finalizarBuscaAlertas();
      }, () => {
        this.loadAlertas = false;
        this.finalizarBuscaAlertas();
      });
    },

    finalizarBuscaAlertas() {
      const callbacks = this.alertaCallbacks.splice(0);
      callbacks.forEach(callback => callback());

      if (this.alertaBuscaPendente) {
        const notificar = this.alertaNotificarPendente;
        const tocarSom = this.alertaTocarSomPendente;
        this.alertaBuscaPendente = false;
        this.alertaNotificarPendente = false;
        this.alertaTocarSomPendente = false;
        this.getAlertas(null, notificar, tocarSom);
      } else {
        this.alertaTipoPendente = null;
      }
    },

    agendarBuscaAlertas(callback, notificarNovos, tocarSom) {
      clearTimeout(this.alertaTimeout);
      this.alertaTimeout = setTimeout(() => this.getAlertas(callback, notificarNovos, tocarSom), 500);
    },

    iniciarPollingAlertas() {
      if (this.alertaIntervalo) return;

      this.alertaIntervalo = setInterval(() => {
        this.getAlertas(null, true);
      }, 120000);
    },

    pararPollingAlertas() {
      clearInterval(this.alertaIntervalo);
      this.alertaIntervalo = null;
    },

    processarNotificacaoEmpresa(data) {
      if (!data) return;

      if (Number(data.tipo_notificacao) === 1) {
        const tipo = Number(data.tipo_alerta);
        if ([1, 2, 3].includes(tipo) && data.status === undefined) {
          this.alertaTipoPendente = tipo;
        }
        this.agendarBuscaAlertas(null, true, !!data.play);
      } else if ([2, 3].includes(Number(data.tipo_notificacao))) {
        this.getInformes(() => {
          this.selecionarMenuInicial();
          this.atualizarContador();
        });
      }
    },

    atualizarContador(informesLidos) {
      const informesNaoLidos = informesLidos ? 0 : this.informes.filter(a => !this.avisosLidos.includes(a.id_informe)).length;
      this.$store.state.novidades = informesNaoLidos + this.ocorrencias.length + this.alertas.length;
      sessionStorage.setItem('novidades', this.$store.state.novidades);
    },

    confirmarResposta({ alerta, acao, motivo, alternative }) {
      const responder = () => this.responderAlerta(alerta, acao, motivo, alternative);
      if (acao.exigeMotivo || alternative) {
        responder();
        return;
      }

      this.$swal({
        title: acao.label,
        text: 'Confirma esta ação?',
        buttons: ['Voltar', 'Confirmar']
      }).then(confirmado => { if (confirmado) responder(); });
    },

    responderAlerta(alerta, acao, motivo, alternative) {
      const payload = { id_alerta: alerta.id, resposta: acao.resposta };
      if (acao.exigeMotivo) payload.motivo = motivo;
      if (alternative) payload.alternative = alternative;

      alerta.processando = true;
      this.$http.post('v2/alertas/responder', payload).then(res => {
        alerta.processando = false;
        if (res.data && res.data.success) {
          this.$store.commit('removeAlerta', alerta.id);
          this.atualizarContador();
          this.$swal({
            title: 'Resposta enviada',
            text: 'Sua resposta foi enviada. Aguarde a confirmação da plataforma.',
            buttons: 'Ok'
          });
        } else {
          this.$swal((res.data || {}).msg || 'Não foi possível responder ao alerta.');
        }
      }, res => {
        alerta.processando = false;
        const mensagem = (res.data || {}).msg || 'Não foi possível responder ao alerta.';
        if (res.status === 404) {
          this.$store.commit('removeAlerta', alerta.id);
          this.atualizarContador();
        }
        if (res.status === 409) this.agendarBuscaAlertas();
        this.$swal(mensagem);
      });
    },

    ignorarAlerta(alerta) {
      this.alertasIgnorando.push(alerta.id);
      this.$store.commit('removeAlerta', alerta.id);
      this.atualizarContador();

      this.$http.post('v2/alertas/ignorar', { alertas: [alerta.id] }).then(res => {
        if (res.data && res.data.success) {
          this.finalizarIgnore(alerta.id);
        } else {
          this.restaurarAlerta(alerta);
          this.$swal((res.data || {}).msg || 'Não foi possível ignorar o alerta.');
        }
      }, res => {
        this.restaurarAlerta(alerta);
        this.$swal((res.data || {}).msg || 'Não foi possível ignorar o alerta.');
      });
    },

    ignorarAlertas(alertas) {
      const ids = alertas.map(alerta => alerta.id);
      this.alertasIgnorando.push(...ids);
      this.$store.commit('setAlertas', this.alertas.filter(alerta => !ids.includes(alerta.id)));
      this.atualizarContador();

      this.$http.post('v2/alertas/ignorar', { alertas: ids }).then(res => {
        if (res.data && res.data.success) {
          ids.forEach(id => this.finalizarIgnore(id));
        } else {
          this.restaurarAlertas(alertas);
          this.$swal((res.data || {}).msg || 'Não foi possível ignorar os alertas.');
        }
      }, res => {
        this.restaurarAlertas(alertas);
        this.$swal((res.data || {}).msg || 'Não foi possível ignorar os alertas.');
      });
    },

    restaurarAlerta(alerta) {
      this.finalizarIgnore(alerta.id);
      if (!this.alertas.some(item => item.id === alerta.id)) {
        const alertas = [...this.alertas, alerta].sort((a, b) => (b.criadoEm || 0) - (a.criadoEm || 0));
        this.$store.commit('setAlertas', alertas);
        this.atualizarContador();
      }
    },

    restaurarAlertas(alertas) {
      const ids = alertas.map(alerta => alerta.id);
      ids.forEach(id => this.finalizarIgnore(id));
      const existentes = this.alertas.map(alerta => alerta.id);
      const restaurados = alertas.filter(alerta => !existentes.includes(alerta.id));
      if (restaurados.length) {
        const lista = [...this.alertas, ...restaurados].sort((a, b) => (b.criadoEm || 0) - (a.criadoEm || 0));
        this.$store.commit('setAlertas', lista);
        this.atualizarContador();
      }
    },

    finalizarIgnore(id) {
      this.alertasIgnorando = this.alertasIgnorando.filter(alertaId => alertaId !== id);
    },

    abrirPedido(id) {
      this.pedidoPreviewId = id;
    },

    toggleMenu(menu) {
      this.menu = menu;
      if (menu === 1) this.getAlertas();
    },

    selecionarMenuInicial() {
      this.menu = this.alertas.length ? 1 : (this.ocorrencias.length ? 2 : 3);
    },

    clearOcorrencias() {
      const qtd = this.$store.state.novidades - this.$store.state.ocorrencias.length;
      this.$store.state.ocorrencias = [];
      this.$store.state.novidades = qtd > 0 ? qtd : 0;
      sessionStorage.setItem('novidades', this.$store.state.novidades);
      localStorage.removeItem('ocorrencias');
    }
  },

  mounted() {
    this.avisosLidos = JSON.parse(localStorage.getItem('avisosLidos') || '[]');
    if (!this.isComanda && !this.isReadOnly) {
      this.getAlertas();

      const processarInformesIniciais = () => {
        this.selecionarMenuInicial();
        this.atualizarContador();

        if (!sessionStorage.getItem('modalNovidades')) {
          sessionStorage.setItem('modalNovidades', 'true');
          if (this.informes.length && this.informes[0].id_informe > parseInt(localStorage.getItem('modalNovidades') || '0')) {
            localStorage.setItem('modalNovidades', this.informes[0].id_informe);
            if (!this.is_mobile) this.openModal();
          }
        }
      };

      if (this.$store.state.informesCarregados) {
        this.loaded = true;
        processarInformesIniciais();
      } else {
        this.getInformes(processarInformesIniciais);
      }

      const socketConectado = this.$socket && this.$socket.connected;
      this.alertaSocketDesconectado = !socketConectado;
      if (!socketConectado) this.iniciarPollingAlertas();
    }
  },

  beforeDestroy() {
    clearTimeout(this.alertaTimeout);
    this.pararPollingAlertas();
  },

  computed: {
    isComanda() { return this.$store.state.is_comanda; },
    isReadOnly() { return this.$store.state.isReadOnly; },
    informes() { return this.$store.state.informes; },
    alertas() { return this.$store.state.alertas; },
    ocorrencias() { return this.$store.state.ocorrencias; },
    modalOcorrencia() { return this.$store.state.modalOcorrencia; }
  },

  watch: {
    modalOcorrencia(aberto) {
      if (aberto) this.openModal(true, 2);
      else this.modalNotificacoes = null;
    }
  },

  sockets: {
    connect() {
      if (this.isComanda || this.isReadOnly) return;

      this.pararPollingAlertas();
      if (this.alertaSocketDesconectado) {
        this.alertaSocketDesconectado = false;
        this.getAlertas(null, true, false);
      }
    },

    disconnect() {
      if (this.isComanda || this.isReadOnly) return;

      this.alertaSocketDesconectado = true;
      this.iniciarPollingAlertas();
    },

    'company-alert'(data) {
      this.processarNotificacaoEmpresa(data);
    },

    notification(data) {
      if (data && data.atualizar_alertas) {
        this.processarNotificacaoEmpresa(data);
      }
    }
  }
}
</script>

<style scoped>
.modal-nov-body { height: calc(100vh - 152px); overflow: auto; }
@media (max-width: 768px) {
  .modal-nov-body { height: calc(100vh - 135px); }
}
</style>
